import { computed, signal } from '@angular/core';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InMemoryRouterService {
  private readonly _currentView = signal<string>('/');
  public readonly hasBack = computed(() => this.viewHistory().length > 1);

  public readonly currentView = this._currentView.asReadonly();
  public readonly viewHistory = signal(['/']);

  public setView(view: string): void {
    this._currentView.set(view);
    this.viewHistory.update((history) => [...history, view]);
  }

  public back(): void {
    this.viewHistory.update((history) => history.slice(0, -1));
    this._currentView.set(this.viewHistory()[this.viewHistory().length - 1]);
  }
}
